import VueRouter from 'vue-router';
import store from '../main/vue-store';
import {getDocumentLang} from '../main/utils';

import NotFound from './views/NotFound.vue';

import MarketplaceAuth from './views/MarketplaceAuth.vue';
import MarketplaceForgotPassword from './views/MarketplaceForgotPassword.vue';
import MarketplaceResetPassword from './views/MarketplaceResetPassword.vue';
import MarketplaceOrderHistory from './views/MarketplaceOrderHistory.vue';
import MarketplaceReturns from './views/MarketplaceReturns.vue';
import MarketplaceSavedCarts from './views/MarketplaceSavedCarts.vue';
import MarketplaceAddresses from './views/MarketplaceAddresses.vue';
import MarketplaceAddressesList from './views/MarketplaceAddressesList.vue';
import MarketplaceAddressAdd from './views/MarketplaceAddressAdd.vue';
import MarketplaceAddressUpdate from './views/MarketplaceAddressUpdate.vue';
import MarketplacePayments from './views/MarketplacePayments.vue';
import MarketplacePaymentsList from './views/MarketplacePaymentsList.vue';
import MarketplacePaymentAdd from './views/MarketplacePaymentAdd.vue';
import MarketplacePaymentUpdate from './views/MarketplacePaymentUpdate.vue';
import MarketplacePersonalDetails from './views/MarketplacePersonalDetails.vue';
import MarketplaceCart from './views/MarketplaceCart.vue';
import MarketplaceCheckout from './views/MarketplaceCheckout.vue';
import MarketplaceOrder from './views/MarketplaceOrder.vue';
import MarketplaceReturn from './views/MarketplaceReturn.vue';
import MarketplaceOrderReturn from './views/MarketplaceOrderReturn.vue';
import MarketplaceGuestOrder from './views/MarketplaceGuestOrder.vue';
import MarketplaceGuestOrderReturn from './views/MarketplaceGuestOrderReturn.vue';
import MarketplaceGuestReturn from './views/MarketplaceGuestReturn.vue';
import MarketplaceSubscriptions from './views/MarketplaceSubscriptions.vue';
import MarketplaceSubscription from './views/MarketplaceSubscription.vue';

import DesignSpecProjects from './views/DesignSpecProjects.vue';
import DesignSpecProject from './views/DesignSpecProject.vue';
import DesignSharedProject from './views/DesignSpecSharedProject.vue';
import DesignSpecCreateProject from './views/global/DesignSpecCreateProject.vue';
import DesignSpecAuthorizationModal from './views/modal/DesignSpecAuthorizationModal.vue';
import DesignSpecEditDetailsModal from './views/modal/DesignSpecEditDetailsModal.vue';
import DesignSpecEditCoverImageModal from './views/modal/DesignSpecEditCoverImageModal.vue';
import DesignSpecDownloadModal from './views/modal/DesignSpecDownloadModal.vue';
import DesignSpecShareModal from './views/modal/DeisgnSpecShareModal.vue';

const router = new VueRouter({
  mode: 'history',
  base: getDocumentLang() !== 'en' && `${getDocumentLang()}/`,
  routes: [
    {
      name: 'marketplace',
      path: '/:langcode?/marketplace',
      redirect: () => {
        if (store.getters['auth/authenticated']) {
          return '/marketplace/account/orders';
        }
        return '/marketplace/auth/login';
      }
    },
    {
      name: 'marketplace-account-orders',
      path: '/:langcode?/marketplace/account/orders',
      component: MarketplaceOrderHistory,
      meta: {authenticated: true}
    },
    {
      name: 'marketplace-account-order',
      path: '/:langcode?/marketplace/account/orders/:code',
      component: MarketplaceOrder,
      meta: {authenticated: true}
    },
    {
      name: 'marketplace-account-order-return',
      path: '/:langcode?/marketplace/account/orders/:code/return',
      component: MarketplaceOrderReturn,
      meta: {authenticated: true}
    },
    {
      name: 'marketplace-account-returns',
      path: '/:langcode?/marketplace/account/returns',
      component: MarketplaceReturns,
      meta: {authenticated: true}
    },
    {
      name: 'marketplace-account-return',
      path: '/:langcode?/marketplace/account/returns/:code',
      component: MarketplaceReturn,
      meta: {authenticated: true}
    },
    {
      name: 'marketplace-account-saved-carts',
      path: '/:langcode?/marketplace/account/saved-carts',
      component: MarketplaceSavedCarts,
      meta: {authenticated: true}
    },
    {
      path: '/:langcode?/marketplace/account/addresses',
      component: MarketplaceAddresses,
      meta: {authenticated: true},
      children: [
        {
          name: 'marketplace-account-addresses',
          path: '/',
          component: MarketplaceAddressesList
        },
        {
          name: 'marketplace-account-address-add',
          path: 'add',
          component: MarketplaceAddressAdd
        },
        {
          name: 'marketplace-account-address-update',
          path: ':id/update',
          component: MarketplaceAddressUpdate
        }
      ]
    },
    {
      path: '/:langcode?/marketplace/account/payments',
      component: MarketplacePayments,
      meta: {authenticated: true},
      children: [
        {
          name: 'marketplace-account-payments',
          path: '/',
          component: MarketplacePaymentsList
        },
        {
          name: 'marketplace-account-payment-add',
          path: 'add',
          component: MarketplacePaymentAdd
        },
        {
          name: 'marketplace-account-payment-update',
          path: ':id/update',
          component: MarketplacePaymentUpdate
        }
      ]
    },
    {
      name: 'marketplace-account-profile',
      path: '/:langcode?/marketplace/account/profile',
      component: MarketplacePersonalDetails,
      meta: {authenticated: true}
    },
    {
      name: 'marketplace-cart',
      path: '/:langcode?/marketplace/cart',
      component: MarketplaceCart
    },
    {
      name: 'marketplace-checkout',
      path: '/:langcode?/marketplace/checkout',
      component: MarketplaceCheckout
    },
    {
      name: 'marketplace-guest-order',
      path: '/:langcode?/marketplace/orders',
      component: MarketplaceGuestOrder
    },
    {
      name: 'marketplace-guest-order-return',
      path: '/:langcode?/marketplace/order/return',
      component: MarketplaceGuestOrderReturn
    },
    {
      name: 'marketplace-guest-return',
      path: '/:langcode?/marketplace/returns',
      component: MarketplaceGuestReturn
    },
    {
      name: 'marketplace-account-subscriptions',
      path: '/:langcode?/marketplace/account/subscriptions',
      component: MarketplaceSubscriptions,
      meta: {authenticated: true}
    },
    {
      name: 'marketplace-account-subscription',
      path: '/:langcode?/marketplace/account/subscriptions/:subscriptionId',
      component: MarketplaceSubscription,
      meta: {authenticated: true}
    },
    {
      name: 'marketplace-auth',
      path: '/:langcode?/marketplace/auth/:tab',
      component: MarketplaceAuth,
      props: route => ({initialTab: route.params.tab})
    },
    {
      name: 'marketplace-auth-login',
      path: '/:langcode?/marketplace/auth',
      redirect: {
        name: 'marketplace-auth',
        params: {tab: 'login'}
      }
    },
    {
      name: 'marketplace-auth-register',
      path: '/:langcode?/marketplace/auth/register',
      redirect: {
        name: 'marketplace-auth',
        params: {tab: 'register'}
      }
    },
    {
      name: 'marketplace-forgot-password',
      path: '/:langcode?/marketplace/forgot-password',
      component: MarketplaceForgotPassword
    },
    {
      name: 'marketplace-reset-password',
      path: '/:langcode?/marketplace/reset-password',
      component: MarketplaceResetPassword
    },
    {
      name: 'designspec',
      path: '/:langcode?/designspec',
      redirect: {name: 'designspec-projects'}
    },
    {
      path: '/:langcode?/designspec/import',
      redirect: {
        path: '/:langcode?/designspec/projects/new'
      }
    },
    {
      path: '/:langcode?/designspec/project',
      redirect: {name: 'designspec-projects'}
    },
    {
      name: 'designspec-projects',
      path: '/:langcode?/designspec/projects',
      component: DesignSpecProjects,
      children: [
        {
          path: 'auth',
          component: DesignSpecAuthorizationModal,
          meta: {modal: true}
        },
        {
          path: 'new',
          component: DesignSpecCreateProject,
          props: route => ({
            defaultName: route.query.name,
            productIds: route.query.productIds
              ? decodeURIComponent(route.query.productIds).split(',')
              : [],
            variationIds: route.query.variationIds
              ? decodeURIComponent(route.query.variationIds).split(
                ','
              )
              : [],
            coverImageId: route.query.coverImageId
              ? route.query.coverImageId
              : null,
            redirectOnCreate: true
          }),
          meta: {modal: true}
        }
      ]
    },
    {
      name: 'designspec-shared',
      path: '/:langcode?/designspec/project/:id/shared/:shareToken',
      component: DesignSharedProject,
      props: true,
      children: [
        {
          name: 'download',
          path:
            '/:langcode?/designspec/project/:id/shared/:shareToken?q=download',
          component: DesignSpecDownloadModal,
          props: true,
          meta: {modal: true}
        }
      ]
    },
    {
      name: 'designspec-project',
      path: '/:langcode?/designspec/project/:id',
      component: DesignSpecProject,
      props: true,
      children: [
        {
          path: 'auth',
          component: DesignSpecAuthorizationModal,
          meta: {modal: true}
        },
        {
          path: 'edit',
          component: DesignSpecEditDetailsModal,
          props: true,
          meta: {modal: true}
        },
        {
          path: 'cover',
          component: DesignSpecEditCoverImageModal,
          props: true,
          meta: {modal: true}
        },
        {
          path: 'download',
          component: DesignSpecDownloadModal,
          props: true,
          meta: {modal: true}
        },
        {
          path: 'share',
          component: DesignSpecShareModal,
          props: true,
          meta: {modal: true}
        }
      ]
    },
    {
      path: '*',
      component: NotFound
    }
  ]
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);

  if (
    to.matched.some(
      record => typeof record.meta.authenticated !== 'undefined'
    )
  ) {
    const isAuth = store.getters['auth/authenticated'];
    const needsAuth = to.matched.reduce(
      (all, record) => all || record.meta.authenticated,
      false
    );

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if (urlParams.has('redirect')) {
      window.location = `${window.location.origin}${urlParams.get('redirect')}`;
      return;
    }

    if (needsAuth) {
      let redirect = '';
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      if (!urlParams.has('sessionExpired')) {
        redirect = `?redirect=${to.path}`;
      }
      return isAuth ? next() : next(`/marketplace/auth/login${redirect}`);
    } else {
      return isAuth ? next('/marketplace') : next();
    }
  } else {
    next();
  }
});

export default router;
